import { ASK_CHOICE_TOOL } from '@/experiences/sales-portal/domain/superintelligence/constants';
import {
  isVisiblePart,
  MessagePart,
} from '@/experiences/sales-portal/domain/superintelligence/blocs/utils/agent-message-parts';
import { ThreadMessage } from '@assistant-ui/core';

export interface ActivityEntry {
  message: ThreadMessage;
  part: MessagePart;
}

export type ThreadSegment =
  | { entries: ActivityEntry[]; key: string; kind: 'activity' }
  | {
      key: string;
      kind: 'bubble';
      message: ThreadMessage;
      parts: MessagePart[];
    };

const isActivityPart = (part: MessagePart) =>
  part.type === 'reasoning' ||
  (part.type === 'tool-call' && part.toolName !== ASK_CHOICE_TOOL);

export const threadSegments = (
  messages: readonly ThreadMessage[],
  isRunning: boolean,
): ThreadSegment[] => {
  const segments: ThreadSegment[] = [];

  messages.forEach((message) => {
    message.content.forEach((part, index) => {
      if (!isVisiblePart(part)) {
        return;
      }
      const key = `${message.id}-${index}`;
      const last = segments[segments.length - 1];

      if (message.role === 'assistant' && isActivityPart(part)) {
        if (last?.kind === 'activity') {
          last.entries.push({ message, part });
        } else {
          segments.push({
            entries: [{ message, part }],
            key,
            kind: 'activity',
          });
        }
        return;
      }
      if (last?.kind === 'bubble' && last.message.id === message.id) {
        last.parts.push(part);
      } else {
        segments.push({ key, kind: 'bubble', message, parts: [part] });
      }
    });
  });

  return segments.filter(
    (segment, index) =>
      segment.kind !== 'activity' ||
      segment.entries.some(({ part }) => part.type === 'tool-call') ||
      (isRunning && index === segments.length - 1),
  );
};
